import React, {useState} from "react";
import NoteLogicFormField from "./NoteLogicFormField";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";


const UpdateNoteLogic = () => {


    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "Note Logics", url: "/note-logics"},
            {content: "Update Note Logic", url: ""}
        ]
    )

    return (
        <>

            <NoteLogicFormField crumbs={crumbs} title={"Update Note Rule"} btnText={"Update"} isEditable={hasPermission(["LOGIC-U"])}/>

        </>
    )


}
export default UpdateNoteLogic;